$(function() {
    //   setTimeout(function() { 
    //     $("button.video-control__play").click();
    //     $("button.ytp-large-play-button").click();
    //     $(".video--image_with_play")[0].src += "?autoplay=1";

    //   }, 4000);

    $('.logoSlider').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.testimonial_slider').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.prd_slider').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });




    $('.testi_slider').slick({
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });


});


// Home Latest 

$(document).ready(function() {
    // main banner
    $(".con-slider").slick({
        mobileFirst: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
            breakpoint: 991.98,
            settings: {
                dots: true
            }
        }],
    });
    // brand wrapper
    $(".brand-slider").slick({
        mobileFirst: true,
        arrows: false,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        responsive: [{
                breakpoint: 575.98,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 2
                },
            },
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 2
                },
            },
        ],
    });
    // best seller
    $(".bs-slider").slick({
        mobileFirst: true,
        arrows: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: `<span class="p-arrow"><img src="https://cdn.shopify.com/s/files/1/0564/9321/1807/files/arrow-c-left.png?v=1655224299" alt="arrow"></span>`,
        nextArrow: `<span class="n-arrow"><img src="https://cdn.shopify.com/s/files/1/0564/9321/1807/files/arrow-c-right.png?v=1655224298" alt="arrow"></span>`,
        responsive: [{
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991.98,
                settings: {
                    arrows: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,

                }
            },
        ],
    });
    // featured collection
    $(".ch-slider").slick({
        mobileFirst: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
                breakpoint: 575.98,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
        ],
    });
    $(".br-slider").slick({
        mobileFirst: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
            breakpoint: 575.98,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, ],
    });
    // social media 
    $(".sw-slider").slick({
        mobileFirst: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
                breakpoint: 575.98,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 1199.98,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10%'

                },
            },
        ],
    });


    //           Zaid Code


    $('.plp-reviews-wrapper').slick({
        mobileFirst: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        responsive: [{
                breakpoint: 576.98,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991.98,
                settings: {
                    slidesToShow: 2,
                }
            },
        ]
    })

    $(".plp-accordion-header-icon").click(function() {
        // removing active class from all plp-accordion-item and adding it to the clicked item
        $(this).closest(".plp-accordion-item").toggleClass("active");

        // changing plp-accordion-header-icon>span text to plus or minus
        $(this).find("span").text(function(i, text) {
            return text === "-" ? "+" : "-";
        });
    })

    let sliderOne = document.getElementById("slider-1");
    let sliderTwo = document.getElementById("slider-2");
    let displayValOne = document.getElementById("range1");
    let displayValTwo = document.getElementById("range2");
    let minGap = 0;
    let sliderTrack = document.querySelector(".slider-track");
    let sliderMaxValue = document.getElementById("slider-1").max;

    function slideOne() {
        if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
            sliderOne.value = parseInt(sliderTwo.value) - minGap;
        }
        displayValOne.textContent = "$" + sliderOne.value;
        fillColor();
    }

    function slideTwo() {
        if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
            sliderTwo.value = parseInt(sliderOne.value) + minGap;
        }
        displayValTwo.textContent = "$" + sliderTwo.value;
        fillColor();
    }

    function fillColor() {
        percent1 = (sliderOne.value / sliderMaxValue) * 100;
        percent2 = (sliderTwo.value / sliderMaxValue) * 100;
        sliderTrack.style.background = "#C5C6C9";
    }

    slideOne();
    slideTwo();



});
const baseUrl = "https://shopequo.com";
const devUrl = "http://127.0.0.1:9292";
const TempUrls = [
    '/vi/products/grass-straws',
    '/vi/products/coffee-straws',
    '/vi/products/sugarcane-straws',
    '/vi/products/coconut-straws',
    '/vi/products/rice-straws',
    '/pages/vi',
    '/vi/collections/drinking-straws',
    '/blogs/ong-hut/cong-dung-cua-ong-hut-gao-san-pham-moi-than-thien-moi-truong',
    '/blogs/ong-hut/ong-hut-co',
    '/blogs/ong-hut/shark-tank-ong-hut-co',
    '/blogs/ong-hut/san-pham-thien-nhien',
    '/blogs/ong-hut/ong-hut-an-duoc',
    '/blogs/ong-hut/ong-hut-ba-mia',
    '/blogs/ong-hut/mua-ong-hut-co-bang',
    '/blogs/ong-hut/cac-loai-ong-hut-than-thien-moi-truong',
    '/blogs/ong-hut/mua-ong-hut-gao',
    '/blogs/ong-hut/ong-hut-tu-nhien',
    '/blogs/ong-hut/ong-hut-huu-co',
    '/blogs/ong-hut/ong-hut-co-kho',
    '/blogs/ong-hut/ong-hut-co-bang-tuoi',
    '/blogs/ong-hut/phan-biet-ong-hut-tu-huy-va-ong-hut-phan-huy-hoan-toan',
    '/blogs/ong-hut/ong-hut-gao-gia-bao-nhieu',
    '/blogs/ong-hut/ong-hut-gao-an-duoc',
    '/blogs/ong-hut/ong-hut-dua',
    '/blogs/ong-hut/ong-hut-co-lau',
    '/blogs/ong-hut/ong-hut-ca-phe',
    '/blogs/ong-hut/mua-ong-hut-ba-mia',
    '/blogs/ong-hut/gia-ong-hut-co',
    '/blogs/ong-hut/ong-hut-gao-dung-duoc-bao-lau',
    '/blogs/ong-hut/mua-ong-hut-co-tphcm',
    '/blogs/ong-hut/mua-ong-hut-co-ha-noi',
    '/blogs/ong-hut/mua-ong-hut-cafe',
    '/vi/blogs/blog/best-reusable-straws',
    '/vi/blogs/blog/7-best-types-of-biodegradable-straws-eco-friendly-compostable',
    '/pages/contact-us-vietnam',
    '/vi/pages/contact-us-vietnam',
    '/collections/ong-hut',
    '/pages/vi-ống-hut ',
    '/vi/pages/vi-ống-hut',
    '/vi/products/ong-hut-dua',
    '/products/ong-hut-dua',
    '/vi/products/ong-hut-gao',
    '/products/ong-hut-gao',
    '/products/ong-hut-ba-mia',
    '/vi/products/ong-hut-ba-mia',
    '/products/ong-hut-ca-phe',
    '/vi/products/ong-hut-ca-phe',
    '/vi/products/ong-hut-co',
    '/products/ong-hut-co',
    '/blogs/ong-hut',
    '/collections/vietnam-products',
    '/collections/equo-limited-edition/gift%20card',
    '/collections/all/limited%20edition',
    '/vi/collections/all/gift%20card',
    '/vi/collections/household-supplies/Limited%20Edition',
    '/vi/collections/equo-reusable-bags/Tote%20Bag',
    '/vi/collections/equo-limited-edition/limited%20edition',
    '/collections/equo-limited-edition/limited%20edition',
    '/collections/household-supplies/Limited%20Edition',
    '/blogs/ong-hut/noi-khong-voi-ong-hut-nhua',
    '/blogs/ong-hut/cac-san-pham-lam-tu-gao',
    '/blogs/ong-hut/xuat-khau-ong-hut-co',
    '/blogs/ong-hut/rac-thai-nhua',
    '/blogs/ong-hut/xuat-khau-ong-hut-co',
    '/blogs/ong-hut/noi-khong-voi-ong-hut-nhua',
    '/blogs/ong-hut/rac-thai-nhua',
    '/blogs/ong-hut/cac-san-pham-tu-ba-mia',
    '/blogs/ong-hut/san-pham-tu-ba-ca-phe',
    '/blogs/ong-hut/cac-san-pham-lam-tu-gao',
    '/blogs/ong-hut/cach-su-dung-va-bao-quan-ong-hut-co',
    '/blogs/ong-hut/cong-dung-cua-ba-ca-phe',
    '/blogs/ong-hut/ba-mia-dung-de-lam-gi',
    '/blogs/ong-hut/tieu-dung-xanh',
    '/blogs/ong-hut/ong-hut-giay',
    '/blogs/ong-hut/loi-song-xanh',
    '/blogs/ong-hut/o-nhiem-dai-duong',
    '/blogs/ong-hut/ong-hut-tre',
    '/blogs/ong-hut/bien-phap-bao-ve-moi-truong',
    '/blogs/ong-hut/ong-hut-nhua',
    '/blogs/ong-hut/ong-hut-co-bang',
    '/blogs/ong-hut/hieu-ung-nha-kinh',
    '/blogs/ong-hut/phan-huu-co',
    '/vi/blogs/blog/biodegradable-straws-not-paper',
    '/vi/blogs/blog/grass-straws',
    '/vi/blogs/blog/biodegradable-sugarcane-straws',
    '/vi/blogs/blog/coconut-straws-a-sustainable-alternative-to-plastic-straws',
    '/vi/blogs/blog/sustainable-straws',
    '/vi/blogs/blog/natural-straws',
    '/blogs/ong-hut/tai-che-nhua',				
    '/blogs/ong-hut/tai-che-rac-thai-nhua',				
    '/blogs/ong-hut/rac-huu-co',				
    '/blogs/ong-hut/cach-u-phan-huu-co',				
    '/blogs/ong-hut/qua-tang-than-thien-moi-truong',				
    '/blogs/ong-hut/san-pham-than-thien-voi-moi-truong',				
    '/blogs/ong-hut/zero-waste-la-gi',				
    '/blogs/ong-hut/bpa-la-gi',				
    '/blogs/ong-hut/loi-song-ben-vung',				
    '/blogs/ong-hut/y-tuong-sang-tao-bao-ve-moi-truong',				
    '/blogs/ong-hut/ong-hut-pla',				
    '/blogs/ong-hut/ong-hut-bang-tre',				
    '/blogs/ong-hut/cay-co-bang',				
    '/blogs/ong-hut/hat-vi-nhua',				
    '/blogs/ong-hut/nhua-phan-huy-trong-bao-lau',				
    '/vi/blogs/blog/best-non-plastic-straws-for-hot-coffee-other-hot-drinks',				
    '/vi/blogs/blog/rice-straws',				
    '/vi/blogs/blog/environmentally-friendly-straws',				
    '/vi/blogs/blog/what-are-biodegradable-straws-made-of-equo',				
    '/vi/blogs/blog/vietnam-grass-straws',				
    '/vi/blogs/blog/plasticless-straws',				
    '/vi/blogs/blog/are-compostable-straws-better',				
    '/vi/blogs/blog/can-you-eat-sugarcane-straws',				
    '/vi/blogs/blog/benefits-of-biodegradable-straws',				
];
const ReUrls = [
    '/vi/collections/ong-hut/products/ong-hut-co',
    '/vi/collections/ong-hut/products/ong-hut-ca-phe',
    '/vi/collections/ong-hut/products/ong-hut-ba-mia',
    '/vi/collections/ong-hut/products/ong-hut-dua',
    '/vi/collections/ong-hut/products/ong-hut-gao',
    '/vi',
    '/vi/collections/ong-hut',
    '/vi/blogs/ong-hut/cong-dung-cua-ong-hut-gao-san-pham-moi-than-thien-moi-truong',
    '/vi/blogs/ong-hut/ong-hut-co',
    '/vi/blogs/ong-hut/shark-tank-ong-hut-co',
    '/vi/blogs/ong-hut/san-pham-thien-nhien',
    '/vi/blogs/ong-hut/ong-hut-an-duoc',
    '/vi/blogs/ong-hut/ong-hut-ba-mia',
    '/vi/blogs/ong-hut/mua-ong-hut-co-bang',
    '/vi/blogs/ong-hut/cac-loai-ong-hut-than-thien-moi-truong',
    '/vi/blogs/ong-hut/mua-ong-hut-gao',
    '/vi/blogs/ong-hut/ong-hut-tu-nhien',
    '/vi/blogs/ong-hut/ong-hut-huu-co',
    '/vi/blogs/ong-hut/ong-hut-co-kho',
    '/vi/blogs/ong-hut/ong-hut-co-bang-tuoi',
    '/vi/blogs/ong-hut/phan-biet-ong-hut-tu-huy-va-ong-hut-phan-huy-hoan-toan',
    '/vi/blogs/ong-hut/ong-hut-gao-gia-bao-nhieu',
    '/vi/blogs/ong-hut/ong-hut-gao-an-duoc',
    '/vi/blogs/ong-hut/ong-hut-dua',
    '/vi/blogs/ong-hut/ong-hut-co-lau',
    '/vi/blogs/ong-hut/ong-hut-ca-phe',
    '/vi/blogs/ong-hut/mua-ong-hut-ba-mia',
    '/vi/blogs/ong-hut/gia-ong-hut-co',
    '/vi/blogs/ong-hut/ong-hut-gao-dung-duoc-bao-lau',
    '/vi/blogs/ong-hut/mua-ong-hut-co-tphcm',
    '/vi/blogs/ong-hut/mua-ong-hut-co-ha-noi',
    '/vi/blogs/ong-hut/mua-ong-hut-cafe',
    '/blogs/blog/best-reusable-straws',
    '/blogs/blog/7-best-types-of-biodegradable-straws-eco-friendly-compostable',
    '/vi/pages/contact-us',
    '/vi/pages/contact-us',
    '/vi/collections/ong-hut',
    '/vi/collections/ong-hut',
    '/vi/collections/ong-hut',
    '/vi/collections/ong-hut/products/ong-hut-dua',
    '/vi/collections/ong-hut/products/ong-hut-dua',
    '/vi/collections/ong-hut/products/ong-hut-gao',
    '/vi/collections/ong-hut/products/ong-hut-gao',
    '/vi/collections/ong-hut/products/ong-hut-ba-mia',
    '/vi/collections/ong-hut/products/ong-hut-ba-mia',
    '/vi/collections/ong-hut/products/ong-hut-ca-phe',
    '/vi/collections/ong-hut/products/ong-hut-ca-phe',
    '/vi/collections/ong-hut/products/ong-hut-co',
    '/vi/collections/ong-hut/products/ong-hut-co',
    '/vi/blogs/ong-hut',
    '/vi/collections',
    '/collections/equo-limited-edition/products/equo-gift-card',
    '/collections/equo-limited-edition',
    '/vi/collections/equo-limited-edition/products/equo-gift-card',
    '/vi/collections/ong-hut',
    '/vi/collections/equo-reusable-bags',
    '/vi/collections/equo-limited-edition',
    '/collections/equo-limited-edition',
    '/collections/drinking-straws',
    '/vi/blogs/ong-hut/noi-khong-voi-ong-hut-nhua',
    '/vi/blogs/ong-hut/cac-san-pham-lam-tu-gao',
    '/vi/blogs/ong-hut/xuat-khau-ong-hut-co',
    '/vi/blogs/ong-hut/rac-thai-nhua',
    '/vi/blogs/ong-hut/xuat-khau-ong-hut-co',
    '/vi/blogs/ong-hut/noi-khong-voi-ong-hut-nhua',
    '/vi/blogs/ong-hut/rac-thai-nhua',
    '/vi/blogs/ong-hut/cac-san-pham-tu-ba-mia',
    '/vi/blogs/ong-hut/san-pham-tu-ba-ca-phe',
    '/vi/blogs/ong-hut/cac-san-pham-lam-tu-gao',
    '/vi/blogs/ong-hut/cach-su-dung-va-bao-quan-ong-hut-co',
    '/vi/blogs/ong-hut/cong-dung-cua-ba-ca-phe',
    '/vi/blogs/ong-hut/ba-mia-dung-de-lam-gi',
    '/vi/blogs/ong-hut/tieu-dung-xanh',
    '/vi/blogs/ong-hut/ong-hut-giay',
    '/vi/blogs/ong-hut/loi-song-xanh',
    '/vi/blogs/ong-hut/o-nhiem-dai-duong',
    '/vi/blogs/ong-hut/ong-hut-tre',
    '/vi/blogs/ong-hut/bien-phap-bao-ve-moi-truong',
    '/vi/blogs/ong-hut/ong-hut-nhua',
    '/vi/blogs/ong-hut/ong-hut-co-bang',
    '/vi/blogs/ong-hut/hieu-ung-nha-kinh',
    '/vi/blogs/ong-hut/phan-huu-co',
    '/blogs/blog/biodegradable-straws-not-paper',
    '/blogs/blog/grass-straws',
    '/blogs/blog/biodegradable-sugarcane-straws',
    '/blogs/blog/coconut-straws-a-sustainable-alternative-to-plastic-straws',
    '/blogs/blog/sustainable-straws',
    '/blogs/blog/natural-straws',
    '/vi/blogs/ong-hut/tai-che-nhua',			
    '/vi/blogs/ong-hut/tai-che-rac-thai-nhua',			
    '/vi/blogs/ong-hut/rac-huu-co',			
    '/vi/blogs/ong-hut/cach-u-phan-huu-co',			
    '/vi/blogs/ong-hut/qua-tang-than-thien-moi-truong',			
    '/vi/blogs/ong-hut/san-pham-than-thien-voi-moi-truong',			
    '/vi/blogs/ong-hut/zero-waste-la-gi',			
    '/vi/blogs/ong-hut/bpa-la-gi',			
    '/vi/blogs/ong-hut/loi-song-ben-vung',			
    '/vi/blogs/ong-hut/y-tuong-sang-tao-bao-ve-moi-truong',			
    '/vi/blogs/ong-hut/ong-hut-pla',			
    '/vi/blogs/ong-hut/ong-hut-bang-tre',			
    '/vi/blogs/ong-hut/cay-co-bang',			
    '/vi/blogs/ong-hut/hat-vi-nhua',			
    '/vi/blogs/ong-hut/nhua-phan-huy-trong-bao-lau',			
    '/blogs/blog/best-non-plastic-straws-for-hot-coffee-other-hot-drinks',			
    '/blogs/blog/rice-straws',			
    '/blogs/blog/environmentally-friendly-straws',			
    '/blogs/blog/what-are-biodegradable-straws-made-of-equo',			
    '/blogs/blog/vietnam-grass-straws',			
    '/blogs/blog/plasticless-straws',			
    '/blogs/blog/are-compostable-straws-better',			
    '/blogs/blog/can-you-eat-sugarcane-straws',			
    '/blogs/blog/benefits-of-biodegradable-straws',			
];
const platform = () => {
    let url = location.href;
    let index = TempUrls.findIndex(item => (baseUrl + item) === url);
    if (index >= 0) {
        return index;
    } else
        return null;
};
const redirect = () => {
    let os = platform();
    console.log(os);
    if (os != null) {
        location.replace(baseUrl + ReUrls[os]);
    }
};
window.onload = redirect();
$(document).ready(function(){
  const canonicalUrls=[
    "https://shopequo.com/vi/products/ong-hut-gao",
    "https://shopequo.com/vi/products/ong-hut-co",
    "https://shopequo.com/vi/products/ong-hut-ba-mia",
    "https://shopequo.com/vi/products/ong-hut-ca-phe",
    "https://shopequo.com/vi/products/ong-hut-dua"
  ];
  const rediCanoUrls=[
    "https://shopequo.com/vi/collections/ong-hut/products/ong-hut-gao",
    "https://shopequo.com/vi/collections/ong-hut/products/ong-hut-co",
    "https://shopequo.com/vi/collections/ong-hut/products/ong-hut-ba-mia",
    "https://shopequo.com/vi/collections/ong-hut/products/ong-hut-ca-phe",
    "https://shopequo.com/vi/collections/ong-hut/products/ong-hut-dua"
  ];
  var caninicalUrl=$('link[rel="canonical"]').attr('href');
  let index=canonicalUrls.findIndex((item)=>item===caninicalUrl);
  $('link[rel="canonical"]').attr('href', rediCanoUrls[index]);
});
